import { Component, Input, OnInit } from '@angular/core';

import { AuthService } from 'src/app/core/auth/auth.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { NavbarService } from 'src/app/core/services/navbar.service';

import { User } from '../../core/interfaces/user.model';
import { AccountService } from '../../core/services/account.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.css']
})
export class MenuSidebarComponent implements OnInit {
  @Input() menuItems = []
  @Input() menuActive = false;

  isLogged = false;
  hasSuscription = false;

  usuario: User;

  appLink = "https://play.google.com/store/apps/details?id=com.mascinemateca.app"

  constructor(private navbarService: NavbarService, private authService: AuthService,
    private helperService: HelperService, private accountService: AccountService, private router: Router) { }

  abrirLogin() {
    this.helperService.abrirModal("login")
  }
  abrirRegistro() {
    this.helperService.abrirModal("register")
  }

  ngOnInit(): void {

    // Escuchar cuando el menu abre o cierra
    this.navbarService.$menuActive.subscribe(estado => {
      this.menuActive = estado;
    });

    //Para cartel de suscribirse
    this.accountService.suscripto$.subscribe(estado => {
      this.hasSuscription = estado;
    })

    // Escuchar cuando el usuario se loguea o desloguea
    this.authService.logged$.subscribe(estado => {
      this.isLogged = estado;

      this.cerrarMenu();

      if (estado) this.cargarUsuario();
    });

    // Escuchar cuando cambia la url
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((val) => {
      this.cerrarMenu();
    });

    // setTimeout(() => { this.abrirMenu() }, 1000)

  }

  abrirMenu() {
    this.navbarService.abrirMenu()
  }


  async cargarUsuario() {
    this.usuario = await this.accountService.getAccount();
  }


  cerrarMenu() {
    this.navbarService.cerrarMenu();
  }

  cerrarSesion() {
    this.authService.logout();
  }

  descargarApp() {
    window.open(this.appLink, "_blank");
  }

  onClickCuenta() {
    this.router.navigateByUrl("/cuenta");
    this.navbarService.cerrarMenu();
  }


}
